import { collection, doc, onSnapshot, query, updateDoc, where } from "firebase/firestore"
import { db } from "../../../common/firebase"
import { AccountReducerAction, chat_message_pending_reducer, get_chat_message_pending_reducer } from "../../../store/actions/createTicketManageFields";
import { useSelector } from "react-redux";

// const StateCodeData = () => {

//    useSelector((state) => {
//       let info = state.OneCommonResponse.ChatInfo

//       console.log(info,"infoinfoinfo")
//    })
//    return ""
// }

export function GetCountSiteNumber(msgStateSetter,setmsgStateSetter,setmsgStateSetterbool,dispatch,counterstate){
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               // })
   var coll = collection(db, "NTMOMCPS_SITES")
   
   // let docResponse = doc(coll, siteId)
   // let finalCollection = collection(docResponse)

   const q = query(
      coll, 
      where("isReadWeb", "==", false)
   );
   


   onSnapshot(q, (QuerySnapshot) => {
      
      let getSiteId=dispatch(get_chat_message_pending_reducer())
      if(getSiteId!=""){
         let docResponse = doc(coll, getSiteId)
         updateDoc(docResponse, {
            isReadWeb:true
         })
      }
      setmsgStateSetterbool(true)
      let messages = [];
      console.log("the querysnapshot =",counterstate, QuerySnapshot)

      

      QuerySnapshot.forEach((doc) => {
         console.log(getSiteId,doc.data(),"getSiteId")
         // console.log(   doc.data(),counterstate.OneCommonResponse.ChatInfo,"finalCollectionfinalCollectiondocdocdoc")

         let chatidSite=""

         // chatidSite=counterstate.OneCommonResponse.ChatInfo?counterstate.OneCommonResponse.ChatInfo.siteId?counterstate.OneCommonResponse.ChatInfo.siteId:"":""

         // alert(chatidSite)
         let allinfo=doc.data()
         let name=allinfo.name

         // console.log(getSiteId!=name)
         if(getSiteId!=name){
            messages.push(name)
         }
         console.log(name,"allinfo.name","allinfo.name")
         
      });

      
      console.log(messages,"allinfo.name","allinfo.name")
      dispatch(chat_message_pending_reducer(messages))


      setmsgStateSetter(messages)
   })

   console.log(q,counterstate,"finalCollectionfinalCollection")
   

}